import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth } from './firebase';
import { fetchUserSubscription } from './backendApi';

// 获取Firebase Functions实例
const functions = getFunctions();

// 创建Stripe结账会话
export const createCheckoutSession = async (priceId: string) => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('User is not signed in');
    }
    
    const createCheckoutSessionFn = httpsCallable(functions, 'create_checkout_session');
    
    const { data } = await createCheckoutSessionFn({
      userId: user.uid,
      priceId,
      successUrl: `${window.location.origin}/mySubscription?success=true`,
      cancelUrl: `${window.location.origin}/pricing?canceled=true`,
    });
    
    return data as { sessionId: string; url: string };
  } catch (error) {
    console.error('Failed to create checkout session:', error);
    throw error;
  }
};

// 获取当前用户的订阅信息
export const getUserSubscription = async () => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('User is not signed in');
    }
    
    const data = await fetchUserSubscription(user.uid);
    
    if (!data.exists) {
      return { subscription: null };
    }
    
    return { subscription: data.subscription };
  } catch (error) {
    console.error('Failed to fetch subscription:', error);
    throw error;
  }
};

// 取消订阅
export const cancelSubscription = async (cancelImmediately = false) => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('User is not signed in');
    }
    
    const cancelSubscriptionFn = httpsCallable(functions, 'cancel_subscription');
    
    const { data } = await cancelSubscriptionFn({ 
      userId: user.uid,
      cancelImmediately
    });
    
    return data as { success: boolean; cancelImmediately: boolean };
  } catch (error) {
    console.error('Failed to cancel subscription:', error);
    throw error;
  }
}; 
